import { forwardRef } from 'react';
import { cn, focusRing } from '../utils/cn';
import { Field, controlBaseClasses } from './Field';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  hideLabel?: boolean;
  hint?: string;
  error?: string | null;
  containerClassName?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hideLabel, hint, error, required, rows = 4, className, containerClassName, ...rest },
  ref,
) {
  return (
    <Field
      label={label}
      hideLabel={hideLabel}
      hint={hint}
      error={error}
      required={required}
      className={containerClassName}
    >
      {({ controlId, describedBy, invalid }) => (
        <textarea
          ref={ref}
          id={controlId}
          rows={rows}
          aria-describedby={describedBy}
          aria-invalid={invalid || undefined}
          required={required}
          className={cn(
            controlBaseClasses,
            'leading-body resize-y px-3 py-2',
            focusRing,
            className,
          )}
          {...rest}
        />
      )}
    </Field>
  );
});
